import {observer} from "mobx-react"
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"
import shop from "shop/shop"
import { Link } from "react-router-dom"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (<Fragment>
			<Table>
				<colgroup>
					<col width="5%" />
					{ <col width="25%" />}
					{ <col width="20%" />}
					{<col width="10%" />}
					<col width="10%" />
					<col width="10%" />
					{<col width="10%" />}
				</colgroup>
				<thead>
				<tr>
					<th>&nbsp;</th>
					<th>{translate("Artikel")}</th>
					{<th>{translate("Lieferbar")}</th>}
					{<th>{translate("Preis/Stück")}</th>}
					{<th>{translate("Preis/VE")}</th>}
					{<th>{translate( "Menge" )}</th>}
					{<th className="tr">
						<div className="tc">{translate( "Summe" )}</div>
					</th>}
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
		</Fragment>

		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	console.log("ProductRow",product)
	return (<Fragment>
			<tr>
			      <td>
				<Link to={`/product/${product.map_id}`}>
					<img
						className="db center"
						height="34"
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
			<td>
				<strong>{product.article_nr}</strong>
				<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
			</td>
			<td>{product.getNotice()} </td>
			{!minimal &&  <td>
				{<div className=" pr2"><Price>{product.price}</Price></div>}
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
        </div>
      </td>}
	  <td>
		<div><Price>{product.price * (product.quantities && product.quantities[0] && product.quantities[0].multi ? product.quantities[0].multi : 1)}</Price></div>
	  </td>

			<td>
				<div className={"nowrap"}>{product.count} VE</div>
				<div className={"nowrap fw4 black-50"}>{product.count  * (product.quantities && product.quantities[0] && product.quantities[0].multi ? product.quantities[0].multi : 1)} Stück</div>
			</td>
			{showTax &&  <td>
				<div><Price>{product.price * product.count * product.unit_multi * product.taxRate}</Price></div>
				<div className={"black-60"}>{product.taxRate * 100} %</div>
			</td>}

			{ <td>
        <div className="tr">
        { <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
        </div>
      </td>}
		</tr>
    </Fragment>
		
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/fiebiger/components/Product/ProductTableReadOnly.js